import React, { Component } from 'react';
import { Modal, List } from 'antd';
import { Actions } from './actions';
export class ActionsMenu extends Component {
    render() {
        return (
            <Modal
                title={'Add Action'}
                onCancel={() => {
                    this.props.onCancel();
                }}
                visible={this.props.visible}
            >
                <List
                    size="small"
                    bordered
                    dataSource={Object.keys(Actions)
                        .map(action_id => {
                            return { action_id, ...Actions[action_id] };
                        })
                        .sort(function(a, b) {
                            if (a.name < b.name) {
                                return -1;
                            }
                            if (a.name > b.name) {
                                return 1;
                            }
                            return 0;
                        })}
                    renderItem={item => (
                        <List.Item
                            style={{ cursor: 'pointer' }}
                            onClick={() => {
                                this.props.onSelect(item);
                                this.props.onCancel();
                            }}
                        >
                            <List.Item.Meta title={item.name} />
                            {item.description}
                        </List.Item>
                    )}
                />
            </Modal>
        );
    }
}



// WEBPACK FOOTER //
// ./src/Account/Bot/TriggerView/ActionsMenu.js